module.exports = __webpack_public_path__ + "static/media/pinGreen.d7793c78.svg";